import { observer } from "mobx-react";
import { Grid } from "@mui/material";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";
import { useCurrentDashboard } from "../useCurrentDashboard";
import SignalsCardSelectorStore from "./AddCards/SignalsCardSelectorStore";
import { useStore } from "utils/useStore";

// Component to display when a dashboard has nothing on it
const DashboardEmpty = observer(() => {
    const dashboard = useCurrentDashboard();
    const signalsCardSelectorStore = useStore(SignalsCardSelectorStore);
    return (
        <Grid item container height="100%">
            <AcxEmptyState
                size="large"
                variant={"newSignals"}
                showButton={dashboard?.dashboardIsEditable}
                onButtonClick={() =>
                    (signalsCardSelectorStore.showReportSelector = true)
                }
            />
        </Grid>
    );
});

export default DashboardEmpty;
